// extracted by mini-css-extract-plugin
export default {"lds-dual-ring":"c42fc78c421d775d9a27","small":"fce93e4cd9dab9e63dcb","center":"d83f68381ee53e74cac4"};